import React from 'react';
import { Select } from 'antd';

interface NodeTypeListProps {
  value?: string;
  onChange?: (value: string) => void;
}

// The options may change in future
const nodeTypes = [
  // { value: null, label: 'None' },
  { value: 'control_node', label: 'Control Nodes' },
  { value: 'field_node', label: 'Field Nodes' },
  { value: 'energy_node', label: 'Energy Nodes' }
];

const NodeTypeList: React.FC<NodeTypeListProps> = ({ value, onChange }) => (
<div>
  <Select
    value={value}
    style={{ width: 180 }}
    onChange={onChange}
    options={nodeTypes}
  />
</div>
);

export default NodeTypeList;
